module.exports = __webpack_public_path__ + "static/media/zoo.67066050.jpg";